import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export interface StartTaskSectionProps {
  title?: string;
  description?: string;
  action?: React.ReactElement;
}

export default function StartTaskSection(props: Readonly<StartTaskSectionProps>) {
  const { title = 'ยังไม่สามารถดูรายละเอียดได้', description = '', action } = props;
  return (
    <NoRowsOverlay
      icon={DescriptionOutlinedIcon}
      title={title}
      description={description}
      action={action}
    />
  );
}
